import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu } from "antd";
import logo from "@/assets/images/logo.png";
import fold from "@/assets/images/fold.png";
import { getQuery } from "@/utils";
import { INDIVIDUATION_HEADER_LIST } from "@/consts/header";
import styles from "./index.module.less";

const NavMenu = ({ changeFoldFunc, showSideNav }) => {
  const [selectedKey, setSelectedKey] = useState("");
  const [openSubMenu, setOpenSubMenu] = useState("");
  const [currentSelectedKey, setCurrentSelectedKey] = useState(selectedKey);
  const [items, setItems] = useState(INDIVIDUATION_HEADER_LIST);
  const navigate = useNavigate();
  const location = useLocation();
  const [current, setCurrent] = useState(null);

  // 获取当前url
  useEffect(() => {
    const name = location.pathname;

    const id = getQuery("id");
    setCurrentSelectedKey(name);
    setSelectedKey(id);
    if (location.hash) {
      setCurrent(`${name}${location.hash}`);
      return;
    }
    setCurrent(name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, getQuery("id")]);

  const handelClick = () => {
    navigate("/");
  };

  const changeFold = () => {
    changeFoldFunc();
  };

  return (
    <>
      <div
        className={styles.header}
        style={{
          transition: "all 0.7s ease 0ms",
          left: showSideNav ? "-593px" : 0,
        }}
      >
        <div className={styles.headerWrapper}>
          <div className={styles.leftWrap}>
            <img
              onClick={handelClick}
              src={logo}
              className={styles.logo}
              alt=""
            />
            <div className={styles.menuInfos}>
              <div className={styles.menusWrap}>
                <Menu
                  selectedKeys={[current]}
                  mode="horizontal"
                  items={items.map((item) => {
                    return {
                      key: item.key,
                      label: (
                        <div
                          onClick={() => {
                            if (!item?.children) {
                              if (item.key === "online") {
                                window.open(
                                  "https://c-121.p.easyliao.com/live/chat.do?c=121&g=121&config=71646"
                                );
                                return;
                              }
                              navigate(item?.key);
                              setCurrent(item?.key);
                            }
                          }}
                          style={{ fontSize: "16px" }}
                        >
                          {item.label}
                          {item.children ? (
                            <></>
                          ) : // <DownOutlined style={{ marginLeft: 10 }} />
                          null}
                        </div>
                      ),
                      children: item.children
                        ? item.children.map((child) => {
                            return {
                              key: child.key,
                              label: (
                                <div
                                  style={{ fontSize: "16px" }}
                                  onClick={() => {
                                    console.log(item, "item");

                                    // if (item.key === 'about') {
                                    //   navigate('about');
                                    //   setCurrent(child?.key);
                                    //   return;
                                    // }
                                    if (child.key === "invite") {
                                      window.open(
                                        "https://jobs-xueda.ourats.com/index/#anchor2"
                                      );
                                    } else {
                                      navigate(child.key);
                                      setCurrent(child?.key);
                                    }
                                  }}
                                >
                                  {child.label}
                                </div>
                              ),
                            };
                          })
                        : undefined,
                    };
                  })}
                />
              </div>
            </div>
          </div>
          <img src={fold} className={styles.fold} onClick={changeFold} alt="" />
        </div>

        {/* <SideNav showSideNav={showSideNav} closeFold={closeFold} /> */}
      </div>
    </>
  );
};

export default NavMenu;
